import BaseApi from './BaseApi'

export default {
  checkAuthEmail(email, companyId) {
    return BaseApi.post(`/v1/auth/email-check`, { email: email, company_id: companyId })
  },
}
